import styled, { css } from "styled-components";

export const CommonTdStyle = css`
  position: relative;
  padding: var(--Spacing-12, 1.2rem) var(--Spacing-8, 0.8rem);
  line-height: 1.8rem;
  border: 1px solid var(--Color-Common-Border-Tertiary, #e5e7eb);
  font-size: 1.2rem;
  font-style: normal;
  font-weight: 400;
  line-height: 130%;
  vertical-align: top;
`;

export const CommonErrorStyles = css`
  background-color: ${({ theme }) => theme.color.neural.gray01};
  color: rgba(60, 71, 87, 0.5);

  a {
    color: rgba(60, 71, 87, 0.5);
  }

  span {
    color: rgba(60, 71, 87, 1);
  }
`;

export const RegulatoryListTableBody = styled.tbody`
  background-color: #ffffff;
`;

export const RegulatoryListTableTr = styled.tr<{
  isError: boolean;
}>`
  ${({ isError }) =>
    isError &&
    css`
      td {
        ${CommonErrorStyles}
      }
    `}
`;

export const RegulatoryListTableId = styled.td`
  ${CommonTdStyle}
  width: 8.8rem;
  background: var(--Color-Common-Bg-Secondary, #f0f2f4);
`;

export const RegulatoryListTableLabelId = styled.td<{
  $hasTooltip?: boolean;
}>`
  ${CommonTdStyle}
  width: 16rem;
  background: var(--Color-Common-Bg-Secondary, #f0f2f4);
  word-break: break-all;

  ${({ $hasTooltip }) =>
    $hasTooltip &&
    css`
      cursor: pointer;

      &:hover {
        background: #e5e7eb;

        .tooltip-wrapper {
          display: block;
        }
      }
    `}
`;

export const RegulatoryListBulletList = styled.ul`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--Spacing-6, 0.6rem);
  margin: 0;
  padding: 0;
`;

export const RegulatoryListBulletItem = styled.li`
  position: relative;
  padding-left: 0.7rem;
  list-style: none;
  word-break: break-all;
`;

export const RegulatoryListBulletItemText = styled.span`
  &::before {
    position: absolute;
    left: 0rem;
    top: 0;
    display: block;
    content: "•";
    color: #2a2f37;
    font-size: 1.4rem;
  }
`;

export const RegulatoryListNumber = styled.div``;

export const RegulatoryListTooltipWrapper = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 100%;
  margin-top: 0.2rem;
  z-index: 100;
  box-sizing: border-box;
  border-radius: var(--Border-Radius-4, 0.4rem);
  border: 1px solid var(--Color-Common-Border-Secondary, #b1b8c4);
  background: var(--Color-Common-Bg-Primary, #fff);
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.16),
    0px 0px 4px 0px rgba(0, 0, 0, 0.12);
  display: none;

  .tooltip {
    color: var(--Color-Common-Text-Primary, #2a2f37);
    font-size: 1.2rem;
    font-weight: 400;
    white-space: normal;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    display: flex;
    width: 100%;
    padding: var(--Spacing-12, 1.2rem) var(--Spacing-8, 0.8rem);
    gap: var(--Spacing-6, 0.6rem);
    border: none;
    word-break: break-all;
  }
`;

export const RegulatoryListTableRegistryAgency = styled.td`
  ${CommonTdStyle}
  width: 10rem;
`;
export const RegulatoryListTableLabelDate = styled.td`
  ${CommonTdStyle}
  width: 10.4rem;
`;

export const RegulatoryListTableCompany = styled.td`
  ${CommonTdStyle}
  width: 20rem;
  min-width: 20rem;
  cursor: pointer;
  position: relative;

  &:hover {
    background: var(--Color-Common-Bg-Interactive-Primary-Subtle, #f0f9ff);

    .tooltip-wrapper {
      display: block;
    }
  }
`;

export const RegulatoryListTableMcEditor = styled.td`
  ${CommonTdStyle}
  width: 8.8rem;
`;

export const RegulatoryListTableFtEditor = styled.td`
  ${CommonTdStyle}
  width: 8.8rem;
`;

export const RegulatoryListTableDate = styled.td`
  ${CommonTdStyle}
  width: 9.2rem;
`;

export const RegulatoryListTableUnsuitable = styled.td<{
  isUnsuitable: boolean;
  isModalOpen?: boolean;
}>`
  ${CommonTdStyle}
  width: 12rem;
  background-color: ${({ isUnsuitable }) =>
    isUnsuitable ? "rgba(219, 15, 114, 0.1)" : ""};

  &:hover {
    background-color: var(--Color-Common-Bg-Warning-Subtle, #feece6);
  }

  &:active {
    background: var(--Color-Common-Bg-Danger-Subtle, #fde7e9);
  }

  ${({ isModalOpen }) =>
    isModalOpen &&
    css`
      background: var(--Color-Common-Bg-Warning-Subtle, #feece6);
    `}
`;

export const RegulatoryListTableStatus = styled.td<{ code: string }>`
  ${CommonTdStyle}
  width: 7.2rem;
  text-align: center;
  vertical-align: middle;
`;

export const RegulatoryListTableClassification = styled.td<{
  status: string;
}>`
  ${CommonTdStyle}
  width: 20rem;
  word-break: break-word;
  overflow-wrap: anywhere;
`;
